const REFERRAL_CODE_KEY = 'referral_code';
const REFERRAL_CODE_TIMESTAMP_KEY = 'referral_code_timestamp';
const EXPIRY_HOURS = 72;

/**
 * Stores a referral code in localStorage with a timestamp
 */
export const setReferralCode = (code: string): void => {
  localStorage.setItem(REFERRAL_CODE_KEY, code);
  localStorage.setItem(REFERRAL_CODE_TIMESTAMP_KEY, Date.now().toString());
};

/**
 * Gets the referral code from localStorage if it hasn't expired (72 hours)
 * Automatically clears expired codes
 */
export const getReferralCode = (): string | null => {
  const code = localStorage.getItem(REFERRAL_CODE_KEY);
  const timestamp = localStorage.getItem(REFERRAL_CODE_TIMESTAMP_KEY);

  if (!code) return null;

  // If no timestamp, treat as expired (legacy data)
  if (!timestamp) {
    clearReferralCode();
    return null;
  }

  const storedTime = parseInt(timestamp, 10);
  const now = Date.now();
  const hoursPassed = (now - storedTime) / (1000 * 60 * 60);

  if (hoursPassed > EXPIRY_HOURS) {
    clearReferralCode();
    return null;
  }

  return code;
};

/**
 * Clears the referral code from localStorage
 */
export const clearReferralCode = (): void => {
  localStorage.removeItem(REFERRAL_CODE_KEY);
  localStorage.removeItem(REFERRAL_CODE_TIMESTAMP_KEY);
};
